import { render } from "./Search.vue?vue&type=template&id=433b78dc&ref=searchContainer"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
script.render = render

export default script